import { HSObject } from "src/v2/types/data";
import { DataObject } from 'shared/providers/types';

export const convertObject = (object: HSObject): DataObject => {
  return object as DataObject;
};
